import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FavoriteItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FavoriteItemsQuery = { __typename?: 'Query', myFavorites: { __typename?: 'Favorites', regulations: Array<{ __typename?: 'Regulation', id: string, name: string, regulationNumber: string }>, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null }>, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string, enumeration: string, parent: { __typename?: 'RegulatoryDocument', id: string, name: string, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null } }>, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null }> } };


export const FavoriteItemsDocument = gql`
    query FavoriteItems {
  myFavorites {
    regulations {
      id
      name
      regulationNumber
    }
    regulatoryDocuments {
      id
      name
      regulation {
        id
        name
        regulationNumber
      }
    }
    paragraphs {
      id
      enumeration
      parent {
        id
        name
        regulation {
          id
          name
          regulationNumber
        }
      }
    }
    requirements {
      id
      name
      requirementId
    }
  }
}
    `;

/**
 * __useFavoriteItemsQuery__
 *
 * To run a query within a React component, call `useFavoriteItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteItemsQuery(baseOptions?: Apollo.QueryHookOptions<FavoriteItemsQuery, FavoriteItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteItemsQuery, FavoriteItemsQueryVariables>(FavoriteItemsDocument, options);
      }
export function useFavoriteItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteItemsQuery, FavoriteItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteItemsQuery, FavoriteItemsQueryVariables>(FavoriteItemsDocument, options);
        }
export type FavoriteItemsQueryHookResult = ReturnType<typeof useFavoriteItemsQuery>;
export type FavoriteItemsLazyQueryHookResult = ReturnType<typeof useFavoriteItemsLazyQuery>;
export type FavoriteItemsQueryResult = Apollo.QueryResult<FavoriteItemsQuery, FavoriteItemsQueryVariables>;